import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {InfoTime, InfoTimeDesc, InfoTimeTag} from "./style";
import {targetAllStatus, getStatusTarget, DISPLAY_STATUS_MAPPING} from '../../../utils/status';
import {formateTimeNumber} from '../../../utils/tool';

export default class Time extends Component {
  static propTypes = {
    itemInfo: PropTypes.object,
    realTimeData: PropTypes.object
  };

  static defaultProps = {
    itemInfo: {},
    realTimeData: {}
  };

  constructor(props) {
    super(props);
  }

  renderTimeTag() {
    const {displayStatus, auctionStatus} = this.props.realTimeData ? this.props.realTimeData : {};
    let status = targetAllStatus[getStatusTarget(displayStatus, auctionStatus)];
    return (<InfoTimeTag
      bgColor={status.tagColor}>
      {status.msg}
    </InfoTimeTag>);
  }

  getTimeStr(displayStatus, auctionStatus, startTime, endTime, remainTime) {
    // 有高优先的显示状态时，不展示时间
    if (!!DISPLAY_STATUS_MAPPING[displayStatus]) return '';

    // 预告中
    if (auctionStatus === 0) {
      let Moment = moment(startTime);
      return `${formateTimeNumber(Moment.month() + 1)}月${formateTimeNumber(Moment.date())}日  ${formateTimeNumber(Moment.hour())}:${formateTimeNumber(Moment.minute())}开始`;
    }
    // 已结束
    if (auctionStatus === 2) {
      let Moment = moment(endTime);
      return `${formateTimeNumber(Moment.month() + 1)}月${formateTimeNumber(Moment.date())}日  ${formateTimeNumber(Moment.hour())}:${formateTimeNumber(Moment.minute())}结束`;
    }
    // 进行中
    if (auctionStatus === 1) {
      let Moment = moment.duration(remainTime);
      return (
        <span className='cur-time-cutdown'>

          {Moment.asDays() > 1 &&
          <Fragment>
            <span className='number'>{formateTimeNumber(parseInt(Moment.asDays()))}</span>
            <span className='font'>天</span>
          </Fragment>
          }

          {
            <Fragment>
              <span className='number'>{formateTimeNumber(Moment.get('hours'))}
              </span>
              <span className='font'>时</span>
            </Fragment>
          }

          {
          <Fragment>
            <span className='number'>{formateTimeNumber(Moment.get('minutes'))}</span>
            <span className='font'>分</span>
          </Fragment>
          }
          {
            <Fragment>
              <span className='number'>{formateTimeNumber(Moment.get('seconds'))} </span>
              <span className='font'>秒</span>
            </Fragment>
          }
        </span>
      );
    }
  }

  render() {
    const {
      displayStatus,
      auctionStatus,
      startTime,
      endTime,
      remainTime
    } = this.props.realTimeData ? this.props.realTimeData : {}
    return (
      <InfoTime bgColor={auctionStatus === 0 || auctionStatus === 1 || auctionStatus === 2 ? '#f3f3f3' : '#fff'}>
        {this.renderTimeTag()}
        <InfoTimeDesc>{
          this.getTimeStr(displayStatus, auctionStatus, startTime, endTime, remainTime)
        }</InfoTimeDesc>
      </InfoTime>
    )
  }
}
